import * as TripQuery from './GraphQL/Queries/tripQuery';
import {
  IGetListTrip,
  ITripCheckIndexNum,
  ITripDetailParams,
  ITripParams,
  TRIP_VARIABLE,
} from './GraphQL/Variables/trip';
import axiosGraphQL from './GraphQL/axiosGraphQL';

const TripAPI = {
  getListTrip: async (params: IGetListTrip) => {
    return await axiosGraphQL.post('/graphql', {
      query: TripQuery.GET_ALL_TRIP,
      variables: TRIP_VARIABLE.getListTrip(params),
    });
  },
  createTripByPlantId: async (params: ITripParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: TripQuery.CREATE_TRIP_BY_PLANT_ID,
      variables: TRIP_VARIABLE.createTripByPlantId(params),
    });
  },
  checkExistedTrip: async (routeId: string) => {
    return await axiosGraphQL.post('/graphql', {
      query: TripQuery.CHECK_EXISTED_TRIP,
      variables: TRIP_VARIABLE.checkExistedTrip(routeId),
    });
  },
  checkExistedIndexNum: async (params: ITripCheckIndexNum) => {
    return await axiosGraphQL.post('/graphql', {
      query: TripQuery.CHECK_EXISTED_INDEX_NUM,
      variables: TRIP_VARIABLE.checkExistedIndexNum(params),
    });
  },
  createTripDetail: async (params: ITripDetailParams) => {
    return await axiosGraphQL.post('/graphql', {
      query: TripQuery.CREATE_TRIP_DETAIL,
      variables: TRIP_VARIABLE.createTripDetail(params),
    });
  },
};

export default TripAPI;
